import { type FC, type ReactNode, useEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'

interface IPortalProps {
  containerId: string | undefined
  children: ReactNode
}

export const Portal: FC<IPortalProps> = ({ containerId, children }) => {
  // -- State ---------------------------------------------------------------
  const [mounted, setMounted] = useState(false)

  // -- Refs ---------------------------------------------------------------
  const ref = useRef<Element | null>(null)

  // -- Effects -------------------------------------------------------------
  useEffect(() => {
    if (!containerId) return

    ref.current = document.getElementById(containerId)
    setMounted(true)
  }, [containerId])

  // -- Layout ---------------------------------------------------------------
  if (!containerId) return null

  return mounted && ref.current ? createPortal(children, ref.current) : null
}
